import styled, { css } from 'styled-components';

export const Navbar = styled.div`
  ${({ theme }) => css`
    background: #fff;
    box-shadow: 0px 16px 24px #00000014;
    position: fixed;
    z-index: ${theme.layers.menu};
    top: 0;
    left: 0;
    right: 0;

    @media (min-width: 992px) {
      box-shadow: 0px 4px 20px #0000000f;
    }
  `}
`;

export const Container = styled.div`
  width: 100%;
  padding-right: 32px;
  padding-left: 32px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 720px;
  }

  @media (min-width: 992px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }
`;

export const WrapperMobile = styled.div`
  height: 72px;
  display: none;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 900px) {
    display: flex;
  }
`;

export const WrapperDesktop = styled.div`
  height: 72px;
  display: none;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 901px) {
    display: flex;
  }
`;

export const LeftContent = styled.div`
  display: none;
  align-items: center;

  gap: 40px;

  @media (min-width: 901px) {
    display: flex;
  }
`;

export const RightContent = styled.div`
  margin-left: 20px;

  @media (max-width: 991px) {
    button {
      width: 180px;
    }
  }
`;

export const Logo = styled.div`
  width: 40px;
  height: 40px;
`;

export const Menu = styled.div`
  width: 32px;
  height: 20px;
  cursor: pointer;
`;

export const None = styled.div`
  height: 100%;
  width: 2rem;
`;
